import useApi from "./useApi";

const useDashboardStats = () => {
  const { get } = useApi();

  // Simple stats (cards)
  const statsQuery = get("/dashboard-stats");

  // Full admin dashboard analytics
  const adminDashboardQuery = get("/admin-dashboard");

  return {
    // Simple stats
    stats: statsQuery.data?.data || {
      total_orders: 0,
      total_products: 0,
      total_customers: 0,
    },

    // Full analytics
    analytics: adminDashboardQuery.data?.data || null,

    // Loading states
    loading:
      statsQuery.isLoading || adminDashboardQuery.isLoading,

    // Error handling
    error:
      statsQuery.error ||
      adminDashboardQuery.error ||
      null,

    // Refetch controls
    refetchStats: statsQuery.refetch,
    refetchAnalytics: adminDashboardQuery.refetch,
  };
};

export default useDashboardStats;
